/**
 * created by wang lei
 纯文本粘贴模式 页面
 *
 */
import React, {Component} from 'react';
import textStick from './textStick.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class TextStickTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let pasteplain = this.props.editor.queryCommandState("pasteplain");
        this.setState({btnChecked: pasteplain});
    }

    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'pasteplain' );
                this.setState({btnChecked:!this.state.btnChecked});
            }}>
                <img className={"editor-paste-plain-tool-btn"} style={style} src={textStick}/>
                <style>{`
                    .editor-paste-plain-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-paste-plain-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-paste-plain-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        )
    }

}